import { useState } from "react";
import "./ChatContactInformation.css";
import ContactInformation from "../../Contact/ContactInformation";
import AddEditContactDialog from "../../Contact/AddEditContactDialog";

const ChatContactInformation = ({ contactInfo }) => {
  const [isAddEditContactDialogShown, setIsAddEditContactDialogShown] =
    useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const contactInfo = Object.fromEntries(formData.entries());
    console.log("contact info", contactInfo);
  };

  return (
    <>
      <AddEditContactDialog
        isOpen={isAddEditContactDialogShown}
        contactID={contactInfo[0][0].ContactID}
        setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
      />

      <div className="title">
        <p className="title">Contact Information</p>
      </div>

      <form method="post" onSubmit={handleSubmit}>
        <ContactInformation
          data={contactInfo[1]}
          contactID={contactInfo[0][0].ContactID}
          campaignID={contactInfo[0][0].CampaignID}
          name={contactInfo[0][0].ContactName}
          setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
          isAddEditButtonShown
        />
      </form>
    </>
  );
};

export default ChatContactInformation;
